// BriefBlock — the what / for-whom / by-when / why grid at the top of a
// composer workbench. The brief is the agent's statement of the task it
// understood it was given.

import type { ComposerBriefShape } from '@/data/types';

interface BriefBlockProps {
    brief: ComposerBriefShape;
}

function BriefField({ label, value }: { label: string; value: string }) {
    return (
        <div className="rounded-md border border-[rgb(var(--color-divider))] bg-[rgb(var(--color-surface-secondary)/0.4)] p-2.5">
            <div className="text-overline uppercase text-[rgb(var(--color-text-tertiary))]">
                {label}
            </div>
            <div className="text-annotation text-[rgb(var(--color-text-primary))]">{value}</div>
        </div>
    );
}

export default function BriefBlock({ brief }: BriefBlockProps) {
    // A draft authored without a full brief (e.g. a seeded/legacy row storing
    // `{}`) renders an em-dash per field rather than a blank box.
    const field = (value: string | undefined): string => value ?? '—';
    return (
        <div data-testid="workbench-brief" className="grid grid-cols-2 gap-2">
            <BriefField label="What" value={field(brief?.what)} />
            <BriefField label="For whom" value={field(brief?.forWhom)} />
            <BriefField label="By when" value={field(brief?.byWhen)} />
            <BriefField label="Why" value={field(brief?.why)} />
        </div>
    );
}
